// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles_modal__1EMmz","container":"styles_container__PzO7R","copyAccessToken":"styles_copyAccessToken__2VgOI","submitModal":"styles_submitModal__33_yO"};